import { ExperienceTypeInterface } from 'pages/Recruiter/Candidates/AddEditProfile/types'

export const transformData = (data: ExperienceTypeInterface) => {
  // Handle location as either a city select object or a string (for backward compatibility)
  const location =
    data.location && typeof data.location === 'object' && 'value' in data.location
      ? (data.location as { value: number; label: string }).label
      : data.location
  const cityId =
    data.location && typeof data.location === 'object' && 'value' in data.location
      ? (data.location as { value: number; label: string }).value
      : undefined

  return {
    title: data.title,
    company: data.company,
    location,
    cityId,
    isWorking: Boolean(data.isWorking),
    fromYear: Number(data.fromYear.value),
    fromMonth: Number(data.fromMonth.value),
    toYear:
      data.toYear && data.toYear.value && data.toYear.value > 0 ? Number(data.toYear.value) : null,
    toMonth: data.toMonth && data.toMonth.value ? Number(data.toMonth.value) : null
  }
}
